import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {PointByPointGameApiModel} from "./point-by-point.game.api-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";
import type {PointByPointPointApiModel} from "../point/point-by-point.point.api-model";
import {PointByPointPointDomainModel} from "../point/point-by-point.point.domain-model";

export class PointByPointGameDomainModel extends BaseDomainModel {
  apiModel: PointByPointGameApiModel;

  constructor(model: PointByPointGameApiModel, competitors: Map<Number, CompetitorDomainModel>) {
    super(model);

    this.competitors = competitors;
    this.score = model.score;
    this.winnerCompetitorId = model.winnerCompetitorId;
    this.servingCompetitorId = model.servingCompetitorId;
    this.hasBreak = model.hasBreak;
    this.isCurrent = model.isCurrent;
    this.points = model.points?.map((point: PointByPointPointApiModel) => new PointByPointPointDomainModel(point, competitors))
  }

  get winnerCompetitor() {
    return this.competitors?.get(this.winnerCompetitorId) || null
  }

  get servingCompetitor() {
    return this.competitors?.get(this.servingCompetitorId) || null
  }
}
